
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/explore",
      function () {
        return require("private-next-pages/home/explore/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/explore"])
      });
    }
  